import { h as l, E as u, c } from "./index94.js";
import { T as w, w as x } from "./index94.js";
import * as o from "react";
import { serializeStyles as f } from "./index95.js";
import "./index96.js";
var i = function(e, r) {
  var s = arguments;
  if (r == null || !l.call(r, "css"))
    return o.createElement.apply(void 0, s);
  var m = s.length, n = new Array(m);
  n[0] = u, n[1] = c(e, r);
  for (var a = 2; a < m; a++)
    n[a] = s[a];
  return o.createElement.apply(null, n);
};
(function(t) {
  var e;
  e || (e = t.JSX || (t.JSX = {}));
})(i || (i = {}));
function g() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  return f(e);
}
function p() {
  var t = g.apply(void 0, arguments), e = "animation-" + t.name;
  return {
    name: e,
    styles: "@keyframes " + e + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
export {
  w as ThemeContext,
  i as createElement,
  g as css,
  i as jsx,
  p as keyframes,
  x as withEmotionCache
};
